/**
 * @copyright (C) 2025, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Charyung Kim (crkim@rsupport.com)
 *
 * @description
 *
 * @created at Mon Jun 09 2025
 **/

import { _T } from "@rfice/language";

import { Button, useToast } from "@/frameworks/designStuff";
import useActivityBookmarkListState from "@/modules/activity/components/SidebarContent/ActivityBookmark/components/hooks/useActivityBookmarkListState";

type ChatBookmarkButtonProps = {
	messageId: string;
	onClickBookmark?: (enable: boolean) => void;
};

export default function ChatBookmarkButton({ messageId, onClickBookmark }: ChatBookmarkButtonProps) {
	const { roomMessageIds } = useActivityBookmarkListState();
	const toast = useToast();

	const isBookmarked = roomMessageIds.has(messageId);

	const handleClickBookmark = () => {
		const newState = !isBookmarked;
		onClickBookmark?.(newState);
		showToast(newState);
	};

	const showToast = (enable: boolean) => {
		const message = enable
			? _T("즐겨찾기에 추가되었습니다. activity에서 확인하세요.")
			: _T("즐겨찾기가 해제되었습니다.");
		toast.show({ type: "success", message });
	};

	return isBookmarked ? (
		<Button.Icon name="StarFill24" size="small_18" onClick={handleClickBookmark} filled="transparent" />
	) : (
		<Button.Icon name="Star24" size="small_18" onClick={handleClickBookmark} filled="transparent" />
	);
}
